"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const User_1 = require("./User");
const Workspace_1 = require("./Workspace");
let WorkspaceMembership = class WorkspaceMembership extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => User_1.User),
    typeorm_1.ManyToOne(() => User_1.User, user => user.workspaceMemberships, {
        onDelete: 'CASCADE',
    }),
    tslib_1.__metadata("design:type", Object)
], WorkspaceMembership.prototype, "user", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace),
    typeorm_1.ManyToOne(() => Workspace_1.Workspace, ws => ws.memberships, {
        onDelete: 'CASCADE',
    }),
    tslib_1.__metadata("design:type", Object)
], WorkspaceMembership.prototype, "workspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.RelationId((obj) => obj.user),
    tslib_1.__metadata("design:type", Number)
], WorkspaceMembership.prototype, "userId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.RelationId((obj) => obj.workspace),
    tslib_1.__metadata("design:type", Number)
], WorkspaceMembership.prototype, "workspaceId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({
        default: true,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], WorkspaceMembership.prototype, "isActive", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({
        default: false,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], WorkspaceMembership.prototype, "isWorkspaceAdmin", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Date, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", Date)
], WorkspaceMembership.prototype, "firstInvitedAt", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Date, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", Date)
], WorkspaceMembership.prototype, "joinedAt", void 0);
WorkspaceMembership = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], WorkspaceMembership);
exports.WorkspaceMembership = WorkspaceMembership;
class WorkspaceMembershipEntity extends WorkspaceMembership {
    toString() {
        return `Workspace Membership #${this.id}`;
    }
}
exports.WorkspaceMembershipEntity = WorkspaceMembershipEntity;
//# sourceMappingURL=WorkspaceMembership.js.map